import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, message, notification, Popconfirm } from 'antd';
import { Route, Switch } from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import {
    cancelComplaintResource,
    checkCancelComplaint,
    checkLastComplaint,
    createResource,
    deleteResource,
    fetchResource,
    getResource,
    getResourceForDownload,
    saveComplaintReportQuery,
    saveResourceQuery,
    updateResource,
} from "../../appRedux/actions/Complaint";
import { fetchResourceForLabel as fetchAssetData } from "../../appRedux/actions/Asset";
import {
    fetchFilter,
    fetchSubDocumentFilter,
    getUnserviceableReport, searchGlobalAssetData,
    togglePageSettingVisible
} from '../../appRedux/actions';
import {
    faviconDynamicFunction,
    getColumnSearchProps,
    getRenderForFieldByType,
    sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import Report from "./report";
import * as _ from 'lodash';

export class Complaint extends Component {
    initialQueryState = {
        sort: {
            field: '',
            order: ''
        },
        pagination: {
            pageSize: 10,
            current: 1
        },
        filters: { status: '{"value":[["Open"]],"type":"String","field":"status"}' }
    };

    initialReportQueryState = {
        sort: {
            field: '',
            order: ''
        },
        pagination: {
            pageSize: 10,
            current: 1
        },
        filters: {},
    };

    state = {
        fields: {
            name: {
                value: '',
            },
            description: {
                value: ''
            }
        },
        query: this.initialQueryState,
        columns: [],
        visibleColumns: []
    };

    constructor(props) {
        super(props);
        props.saveResourceQuery(this.initialQueryState);
        props.saveComplaintReportQuery(this.initialReportQueryState);
    }

    componentDidMount() {
        this.fetchList();
        this.props.getUnserviceableReport();
        this.props.fetchFilter(this.props.resourceName);
        this.props.fetchSubDocumentFilter('Document');
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
            const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
            this.setState({
                visibleColumns: [...columns, 'jobCard'],
            }, () => {
                this.renderColumns(nextProps.filters, this.state.visibleColumns);
            })
        }
    }

    handleColumnChange = (value, array) => {
        const { filters } = this.props;
        this.renderColumns(filters, value);
    };

    handleFilter = (selectedKeys, confirm, data) => {
        const query = { ...this.props.query };
        query.filters[data.field] = JSON.stringify({
            value: selectedKeys,
            type: data.type,
            field: data.field
        });
        this.props.saveResourceQuery(query);
        confirm();
        this.fetchList();
    };

    handleReportFilter = (selectedKeys, confirm, data) => {
        const query = { ...this.props.reportQuery };
        query.filters[data.filterField] = JSON.stringify({
            value: selectedKeys,
            type: data.type,
            field: data.filterField,
        });
        this.props.saveComplaintReportQuery(query);
        confirm();
        this.props.getUnserviceableReport();
    };

    handleReset = (clearFilters, data) => {
        const query = { ...this.props.query };
        delete query.filters[data.field];
        this.props.saveResourceQuery(query);
        clearFilters();
        this.fetchList();
    };

    handleReportReset = (clearFilters, data) => {
        const query = { ...this.props.reportQuery };
        delete query.filters[data.filterField];
        this.props.saveResourceQuery(query);
        clearFilters();
        this.props.getUnserviceableReport();
    };

    handleChange = (pagination, filters, sorter) => {
        const query = { ...this.props.query };
        query.pagination = { ...query.pagination, current: pagination.current };
        query.sort = sorter;

        this.props.saveResourceQuery(query);
        this.fetchList();
    };

    handleReportChange = (pagination, filters, sorter) => {
        const query = { ...this.props.reportQuery };
        query.pagination = { ...query.pagination, current: pagination.current };
        query.sort = sorter;
        this.props.saveComplaintReportQuery(query);
        this.props.getUnserviceableReport();
    };

    handleFormChange = (changedFields) => {
        this.setState(({ fields }) => ({
            fields: { ...fields, ...changedFields },
        }));
    };

    renderColumns = (filters, selectedColumns) => {
        filters = filters || this.props.filters;
        const columns = [];
        const { resourceName } = this.props;

        Object.keys(filters).forEach((item) => {

            if (item === '_id') {
                return;
            }

            if (selectedColumns.indexOf(item) === -1) {
                return;
            }

            columns.push({
                title: sanitizeFieldName(item),
                dataIndex: filters[item].field,
                sorter: true,
                render: (value) => getRenderForFieldByType(value, filters[item].type, item),
                ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
            })
        });

        if (selectedColumns.indexOf('jobCard') >= 0) {
            columns.push({
                title: 'Job Card',
                dataIndex: 'jobCard',
                key: 'jobCard',
                render: (value, data) => {
                    if (value) {
                        return <Button onClick={() => this.jobCardReport(value.id)}>Open {value.jobCardNo}</Button>
                    }
                    if (data.status && data.status !== 'Cancelled') {
                        return <Button onClick={() => this.openJobCard(data._id, data.complaintDate, data.location._id)}>Open Job
                            Card</Button>
                    }
                },
            });
        }

        columns.push({
            title: 'Action',
            key: 'action',
            render: (record) => (
                <div>
                    <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                        roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                            return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>Edit</Button>
                        }} />

                    <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                        roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                            return <Popconfirm
                                title="Are you sure you want to delete this record?"
                                onConfirm={() => {
                                    this.deleteResource(record._id, record.location, record.status);
                                }}
                                onCancel={this.cancelDelete}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button style={{ marginLeft: '10px' }} type="danger" size='small'>Delete</Button>
                            </Popconfirm>
                        }} />

                    {/*<AccessControl resource={this.props.resourceName} permissionNeeded={'u'}*/}
                    {/*               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {*/}
                    {/*  return <Popconfirm*/}
                    {/*    title="Are you sure you want to cancel this complaint?"*/}
                    {/*    onConfirm={() => {*/}
                    {/*      this.props.cancelComplaintResource(record._id, record);*/}
                    {/*    }}*/}
                    {/*    onCancel={this.cancelComplaint}*/}
                    {/*    okText="Yes"*/}
                    {/*    cancelText="No"*/}
                    {/*  >*/}
                    {/*    <Button*/}
                    {/*      disabled={ record && record.status==="Cancelled"}*/}
                    {/*      style={{marginLeft: '10px'}}*/}
                    {/*      type="danger"*/}
                    {/*      size='small'>Cancel Complaint</Button>*/}
                    {/*  </Popconfirm>*/}
                    {/*}}/>*/}

                </div>
            ),
        });

        this.setState({
            visibleColumns: selectedColumns,
            columns
        })
    };

    // clearAll = () => {
    //   this.props.saveResourceQuery(this.initialQueryState);
    //   this.fetchList();
    // };

    clearAll = () => {
        const clearQueryState = {
            sort: {
                field: '',
                order: ''
            },
            pagination: {
                pageSize: 10,
                current: 1
            },
            filters: {},
        };
        //this.props.saveResourceQuery(this.initialQueryState);
        this.props.saveResourceQuery(clearQueryState);
        this.fetchList();
    };

    fetchList = () => {
        this.props.getResource();
    };

    createResource = (values) => {
        values.documents = values.documents || [];
        this.props.createResource(values);
    };

    updateResource = (values, id, urlForBackJobCardReport) => {
        values.documents = values.documents || [];
        this.props.updateResource(values, id, urlForBackJobCardReport);
    };

    deleteResource = async (id, location, status) => {
        const data = await this.props.checkLastComplaint({ id: id, location: location._id });
        if (data && data.code === 403) {
            const result = await window.confirm('The complaint cannot be deleted. Do you want to cancel the complaint ?')
            if (result && result === true && status && status === 'Cancelled') {
                message.error('Cancelled Already');
            } else if (result && result === true && status && status !== 'Cancelled') {
                const cancelData = await this.props.checkCancelComplaint(id);
                if (cancelData && cancelData.code === 202 && cancelData.message) {
                    const args = {
                        message: 'Notification Message',
                        description: cancelData && cancelData.message ? cancelData.message : '',
                        duration: 4,
                    };
                    notification.open(args);
                }
            } else {
                message.error('Cancelled');
            }
        } else {
            const args = {
                message: 'Notification Message',
                description: data && data.message ? data.message : '',
                duration: 5,
            };
            notification.open(args);
        }
        this.fetchList();
    };

    cancelDelete = () => {
        message.error('Cancelled');
    };
    cancelComplaint = () => {
        message.error('Complaint Not Cancelled');
    };

    create = () => {
        const { match } = this.props;
        this.props.history.push(`${match.url}/add`);
    };

    jobCardReport = (id) => {
        const { match } = this.props;
        this.props.history.push(`/job-card/report/${id}`);
    }

    openJobCard = (id, complaintDate, locationId) => {
        const { match } = this.props;
        this.props.history.push({
            pathname: '/job-card/add',
            state: { complaintId: id, complaintDate: complaintDate, locationId: locationId, source: 'complaint' }
        });
    }

    edit = (id) => {
        const { match } = this.props;
        this.props.history.push(`${match.url}/edit/${id}`);
    };

    downloadToCSV = () => {
        const columns = [];
        this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
        this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "EquipmentComplaint");
    }

    render() {
        const {
            match,
            history,
            data,
            resource,
            edit,
            fetchResource,
            loading,
            filters,
            modules,
            authUser,
            resourceName,
            report,
            getUnserviceableReport
        } = this.props;
        let { columns, visibleColumns } = this.state;
        // console.log(columns, visibleColumns);
        // columns = columns.filter(value => value.key !== 'status');
        // if visible column contains status
        // then override coloum staus object to remove search filter
        faviconDynamicFunction(authUser);
        return (<div>
            <h2>{((history && history.location && history.location.pathname)
                !== '/complaint/asset-unserviceable-report') ?
                null : 'Asset Unserviceable Report'}</h2>

            <Switch>
                <Route path={`${match.url}`} exact
                    render={() => <List columns={columns}
                        visibleColumn={visibleColumns}
                        data={data}
                        clearFilter={this.clearAll}
                        filters={{ ...filters, jobCard: { field: 'jobCard' } }}
                        handleChange={this.handleChange}
                        columnChange={this.handleColumnChange}
                        downloadToCSV={this.downloadToCSV}
                        title={resourceName}
                        size={'default'}
                        create={this.create}
                        pagination={this.props.query.pagination}
                        loading={loading}
                        authUser={authUser}
                    />
                    } />
                <Route path={`${match.url}/add/:asset?`}
                    render={(props) => <Create data={{}}
                        authUser={this.props.authUser}
                        filters={filters}
                        modules={modules}
                        title={'CREATE'}
                        subDocumentFilters={this.props.subDocumentFilters}
                        resource={resourceName}
                        onChange={this.handleFormChange}
                        onSubmit={this.createResource}
                        fetchAsset={this.props.fetchAssetData}
                        loading={loading}
                        assetData={this.props.assetData}
                        paramAssetData={this.props.paramAssetData}
                        assetSearchLoading={this.props.assetSearchLoading}
                        searchGlobalAssetData={this.props.searchGlobalAssetData}
                        // togglePageSettingVisible={this.props.togglePageSettingVisible}
                        // pageSettingVisible={this.props.pageSettingVisible}
                        {...props}
                    />
                    } />
                <Route path={`${match.url}/edit/:id`}
                    render={(props) => <Create data={edit}
                        authUser={this.props.authUser}
                        filters={filters}
                        modules={modules}
                        title={'EDIT'}
                        resource={resourceName}
                        fetch={fetchResource}
                        onChange={this.handleFormChange}
                        onSubmit={this.updateResource}
                        loading={loading}
                        assetData={this.props.assetData}
                        assetSearchLoading={this.props.assetSearchLoading}
                        searchGlobalAssetData={this.props.searchGlobalAssetData}
                        // togglePageSettingVisible={this.props.togglePageSettingVisible}
                        // pageSettingVisible={this.props.pageSettingVisible}
                        {...props}
                    />
                    } />
                <Route path={`${match.url}/asset-unserviceable-report`}
                    render={(props) => <Report
                        filters={filters}
                        modules={modules}
                        title={'REPORT'}
                        report={report}
                        handleFilter={this.handleReportFilter}
                        handleReset={this.handleReportReset}
                        pagination={this.props.reportQuery.pagination}
                        handleChange={this.handleReportChange}
                        getUnserviceableReport={getUnserviceableReport}
                        resource={resourceName}
                        fetch={fetchResource}
                        loading={loading}
                        {...props}
                    />
                    } />
            </Switch>
        </div>)
    }
}

const mapStateToProps = ({ auth, complaint, commonData, asset }) => {
    return {
        authUser: auth.authUser,
        total: complaint.total,
        data: complaint.resources,
        resource: complaint.resource,
        edit: complaint.edit,
        query: complaint.query,
        loading: commonData.loading,
        filters: commonData.filters,
        modules: commonData.modules,
        report: complaint.report,
        reportQuery: complaint.reportQuery,
        subDocumentFilters: commonData.subDocumentFilters,
        // pageSettingVisible: commonData.pageSettingVisible,
        assetData: commonData.assetSearchData,
        assetSearchLoading: commonData.assetSearchLoading,
        paramAssetData: asset.labelData
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getResource,
        getResourceForDownload,
        createResource,
        checkLastComplaint,
        checkCancelComplaint,
        fetchResource,
        updateResource,
        deleteResource,
        saveResourceQuery,
        fetchFilter,
        getUnserviceableReport,
        saveComplaintReportQuery,
        fetchSubDocumentFilter,
        cancelComplaintResource,
        searchGlobalAssetData,
        // togglePageSettingVisible,
        fetchAssetData
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(Complaint);
